import s from './vacation-alert.module.scss'
import { NavLink } from 'react-router-dom'
import { IconBeach } from '@tabler/icons-react'

export const VacationAlert = () => (
	<div className={s.alert}>
		<IconBeach size={24} className={s.icon} />
		<div className={s.content}>
			<h3>Вы в отпуске</h3>
			<p>Новые записи учеников отключены. Запись по активным пакетам остаётся доступной.</p>
			<NavLink to='/settings' className={s.link}>Изменить в настройках</NavLink>
		</div>
	</div>
)
